angular.module('impactx.help').controller('HelpCtrl', [
    '$scope',
    'themeFactory',
    'HelpService',
    'TranslationService',
    HelpController]);

function HelpController($scope, themeFactory, HelpService, TranslationService) {
    var self = this;

    var maxHistSize = 10;
    self.lastSelected = null;
    self.selectedItem = null;
    self.history = [];
    self.availableArticles = [];
    self.requestInProgress = false;
    self.maximized = false;
    // initial
    var layout = {
        top: '20%',
        left: '30%',
        height: '700px',
        width: '500px'
    };

    self.trns = {
        help: TranslationService.get('help'),
        search: TranslationService.get('search')
    };

    self.getTheme = function () {
        return themeFactory.getTheme();
    };

    self.getCurrentRoute = function () {
        return HelpService.getCurrentRoute();
    };

    self.close = function (event) {
        HelpService.close(event);
    };

    self.maximize = function (event) {
        var dialogElement = angular.element("#help-dialog");

        layout.top = dialogElement[0].getBoundingClientRect().top;
        layout.left = dialogElement[0].getBoundingClientRect().left;
        layout.height = dialogElement.prop('offsetHeight');
        layout.width = dialogElement.prop('offsetWidth');

        dialogElement.css({
            top: '0',
            left: '0',
            height: '100%',
            width: '100%',
            margin: '0'
        });

        var cardHeader = angular.element("#help-dialog > md-card-header");
        cardHeader.css({
            cursor: 'default'
        });

        var resizeHandle = angular.element("#resize-handler");
        resizeHandle.hide();

        self.maximized = true;
    };

    self.restore = function (event) {
        var dialogElement = angular.element("#help-dialog");
        dialogElement.css({
            top: layout.top,
            left: layout.left,
            height: layout.height,
            width: layout.width,
            margin: '8px'
        });

        var cardHeader = angular.element("#help-dialog > md-card-header");
        cardHeader.css({
            cursor: 'move'
        });

        var resizeHandle = angular.element("#resize-handler");
        resizeHandle.show();

        self.maximized = false;
    };

    self.selectedItemChanged = function(event) {
        if(self.lastSelected) {
            self.history.push(self.lastSelected);
            if(self.history.length > maxHistSize) {
                self.history.shift();
            }
        }
        if(self.selectedItem) {
            self.lastSelected = self.selectedItem;
        }
        else {
            self.lastSelected = null;
        }
    };

    self.back = function(event) {
        if(self.history && self.history.length > 0) {
            self.selectedItem = self.history.pop();
            self.lastSelected = null;
        }
    };

    self.searchDoc = function () {
        if (self.searchText && self.searchText.length > 2) {
            self.requestInProgress = true;
            return HelpService.searchDocument(self.searchText).then(function (response) {
                self.requestInProgress = false;
                var result = impactX.isDefined(response, "data.suggests");
                if(result) {
                    return result;
                }
                return [];
            });
        }
        return [];
    };

    self.getDoc = function () {
        self.requestInProgress = true;
        HelpService.getDocument().then(function (response) {
            self.requestInProgress = false;
            if(response && response.data && response.data.title) {
                self.selectedItem = response.data;
            }
        });
    };
    self.getDoc();
}